// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".KSJ7THQRxV1OPjQHoMPR{width:100%;background-color:#fff;box-shadow:0px 4px 10px rgba(200,227,250,.5);margin-top:18px;margin-bottom:20px}@media(min-width: 768px){.KSJ7THQRxV1OPjQHoMPR{margin-top:32px;margin-bottom:32px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userSteps": "KSJ7THQRxV1OPjQHoMPR"
};
export default ___CSS_LOADER_EXPORT___;
